import { lazy } from 'react';
import {
  actionsIcon,
  debugIcon,
  moduleIcon,
  rolesIcon,
  subGroupsIcon,
  teamsIcon,
  userIcon
} from '@tools/ui/assets';
import type { TRoutes } from '@tools/ui/types';
import { UnorderedListOutlined24 } from '../components/icons';

const prefixPath = '/settings';

const UsersTable = lazy(
  () =>
    import(
      /* webpackChunkName: "SettingsRoutes" */ '../pages/settings/components/users/users.table'
    )
);

const TeamsTable = lazy(
  () =>
    import(
      /* webpackChunkName: "SettingsRoutes" */ '../pages/settings/components/teams/teams.table'
    )
);

const SquadsTable = lazy(
  () =>
    import(
      /* webpackChunkName: "SettingsRoutes" */ '../pages/settings/components/squads/squads.table'
    )
);

const RolesTable = lazy(
  () =>
    import(
      /* webpackChunkName: "SettingsRoutes" */ '../pages/settings/components/roles/roles.table'
    )
);

const ActionsTable = lazy(
  () =>
    import(
      /* webpackChunkName: "SettingsRoutes" */ '../pages/settings/components/actions/actions.table'
    )
);

const CommonComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "SettingsRoutes" */ '../pages/settings/components/common'
    )
);

const ModulesTable = lazy(
  () =>
    import(
      /* webpackChunkName: "SettingsRoutes" */ '../pages/settings/components/modules/modules.table'
    )
);

const ActionLogsTable = lazy(
  () =>
    import(
      /* webpackChunkName: "SettingsRoutes" */ '../pages/settings/components/action-logs/action-logs.table'
    )
);

export const settingsRoutes: TRoutes = [
  {
    redirectFrom: [`${prefixPath}/`, `${prefixPath}/*`]
  },
  {
    name: 'Users',
    path: `${prefixPath}/users`,
    component: UsersTable,
    exact: true,
    icon: userIcon
  },
  {
    name: 'Teams',
    path: `${prefixPath}/teams`,
    component: TeamsTable,
    exact: true,
    icon: teamsIcon
  },
  {
    name: 'Squads',
    path: `${prefixPath}/squads`,
    component: SquadsTable,
    exact: true,
    icon: subGroupsIcon
  },
  {
    name: 'Roles',
    path: `${prefixPath}/roles`,
    component: RolesTable,
    exact: true,
    icon: rolesIcon
  },
  {
    name: 'Actions',
    path: `${prefixPath}/actions`,
    component: ActionsTable,
    exact: true,
    icon: actionsIcon
  },
  {
    name: 'Action Logs',
    path: `${prefixPath}/action-logs`,
    component: ActionLogsTable,
    exact: true,
    icon: UnorderedListOutlined24
  },
  {
    name: 'Modules',
    path: `${prefixPath}/modules`,
    component: ModulesTable,
    exact: true,
    icon: moduleIcon
  },
  {
    name: 'Debug',
    path: `${prefixPath}/debug`,
    component: CommonComponent,
    exact: true,
    icon: debugIcon
  }
];
